/**
 * KAUTION BUNDLE & SYNC SCRIPT (Universal: Drawer & Cart Page)
 * Version: 9.0 (Final Master - Alle Fixes kombiniert)
 * Enthält: Properties, Empty-State Fix, Smart-Quantity Sync, Re-Check Loop
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // --- KONFIGURATION ---
  const DEPOSIT_PRODUCT_TYPE = "Kaution"; 
  let isUpdating = false; 

  const SELECTORS = {
    productForm: 'product-form',
    submitButton: 'button[type="submit"]',
    depositInput: 'deposit-variant-id',
    cartDrawer: 'cart-drawer',
    cartPageItems: 'cart-items', 
    cartItem: '.cart-item',
    cartBubble: '#cart-icon-bubble',
    keyElement: '[data-key]' 
  };

  // ---------------------------------------------------------
  // A: ADD TO CART (Mit Properties für Trennung)
  // ---------------------------------------------------------
  function initAddToCartInterceptor() {
    const productForm = document.querySelector(SELECTORS.productForm);
    if (!productForm) return;

    const depositInput = document.getElementById(SELECTORS.depositInput);
    if (!depositInput) return; 

    const submitButton = productForm.querySelector(SELECTORS.submitButton);
    if (!submitButton) return;

    submitButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const formData = new FormData(productForm.querySelector('form'));
      const mainVariantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;
      
      const depositVariantId = depositInput.value;
      const mainProductTitle = depositInput.getAttribute('data-main-product-title') || 'Produkt';

      const itemsToAdd = [
        { 
          id: mainVariantId, 
          quantity: parseInt(quantity) 
        },
        { 
          id: depositVariantId, 
          quantity: parseInt(quantity),
          properties: { 
            'Kaution für': mainProductTitle 
          }
        }
      ];

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(response => response.json())
      .then(() => {
        handleCartOpenAction();
      })
      .catch((error) => {
        console.error('Fehler:', error);
        alert('Fehler beim Hinzufügen. Bitte Seite neu laden.');
      })
      .finally(() => {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');
      });
    });
  }

  // ---------------------------------------------------------
  // B: SYNC LOGIC (Smart Matching nach Namen)
  // ---------------------------------------------------------
  function syncDeposits() {
    if (isUpdating) return;

    const allCartItems = document.querySelectorAll(SELECTORS.cartItem);
    if (allCartItems.length === 0) return;

    // Mapping erstellen: "Produktname" -> Menge
    let requiredMap = {}; // Bedarf: { 'Sattel': 2 }
    let existingMap = {}; // Bestand: { 'Sattel': [ {key: '...', qty: 1} ] }

    allCartItems.forEach(item => {
      if (item.offsetParent === null && !item.closest('cart-drawer')) return;

      const qty = parseInt(item.getAttribute('data-quantity')) || 0;
      const productType = item.getAttribute('data-product-type');
      const requiredDepositId = item.getAttribute('data-deposit-required');
      
      // Die neuen Attribute aus deinem Liquid
      const productTitle = item.getAttribute('data-product-title'); 
      const depositRef = item.getAttribute('data-deposit-reference');

      // 1. BEDARF ermitteln (Mietprodukte scannen)
      if (requiredDepositId && productTitle) {
        if (!requiredMap[productTitle]) requiredMap[productTitle] = 0;
        requiredMap[productTitle] += qty;
      }

      // 2. BESTAND ermitteln (Kautionen scannen)
      if (productType === DEPOSIT_PRODUCT_TYPE && depositRef) {
        const keyEl = item.querySelector(SELECTORS.keyElement);
        const lineKey = keyEl ? keyEl.getAttribute('data-key') : null;
        
        if (lineKey) {
           if (!existingMap[depositRef]) existingMap[depositRef] = [];
           existingMap[depositRef].push({ key: lineKey, quantity: qty });
        }
      }
    });

    let updates = {};
    let needsUpdate = false;

    // Alle Produktnamen durchgehen, die wir gefunden haben (Bedarf oder Bestand)
    const allTitles = new Set([...Object.keys(requiredMap), ...Object.keys(existingMap)]);

    allTitles.forEach(title => {
      const needed = requiredMap[title] || 0;
      const lines = existingMap[title] || [];
      const currentTotal = lines.reduce((sum, line) => sum + line.quantity, 0);

      // FALL A: Zu wenig Kaution (Menge erhöhen)
      if (currentTotal < needed) {
        const missing = needed - currentTotal;
        
        if (lines.length > 0) {
          // Wir erhöhen die erste gefundene Kautions-Zeile für dieses Produkt
          const targetLine = lines[0];
          updates[targetLine.key] = targetLine.quantity + missing;
          needsUpdate = true;
        } 
        // Falls lines.length == 0 (Kaution fehlt ganz), kann update.js nicht helfen.
        // Das passiert aber nur, wenn man Kaution manuell löscht, was durch CSS verhindert ist.
      }

      // FALL B: Zu viel Kaution (Löschen/Reduzieren)
      else if (currentTotal > needed) {
        let removeLeft = currentTotal - needed;
        
        lines.forEach(line => {
          if (removeLeft <= 0) return;

          if (line.quantity <= removeLeft) {
            updates[line.key] = 0; // Ganze Zeile löschen
            removeLeft -= line.quantity;
          } else {
            updates[line.key] = line.quantity - removeLeft; // Menge reduzieren
            removeLeft = 0;
          }
          needsUpdate = true;
        });
      }
    });

    // Update an Shopify senden
    if (needsUpdate) {
      isUpdating = true;
      console.log('Smart Sync Update:', updates);
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(res => res.json())
      .then(() => {
        refreshOnlyUI();
      })
      .catch(err => {
        console.error('Sync Fehler:', err);
        isUpdating = false;
      });
    }
  }

  // ---------------------------------------------------------
  // UI HELPER: DRAWER ÖFFNEN (Mit Empty-State Fix)
  // ---------------------------------------------------------
  function handleCartOpenAction() {
    const cartDrawer = document.querySelector(SELECTORS.cartDrawer);
    
    if (cartDrawer) {
      fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
        .then((res) => res.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const newContent = html.querySelector(SELECTORS.cartDrawer);
          
          if (newContent) {
            cartDrawer.innerHTML = newContent.innerHTML;
            
            // WICHTIG: Klassen übernehmen (fixiert den leeren Header)
            cartDrawer.className = newContent.className; 
            
            updateBubble();
            
            cartDrawer.classList.add('active'); 
            cartDrawer.setAttribute('aria-modal', 'true');
            cartDrawer.setAttribute('open', '');
            document.body.classList.add('overflow-hidden'); 
            
            // Check nach dem Öffnen
            setTimeout(syncDeposits, 300);
          }
        });
    } else {
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  }

  // ---------------------------------------------------------
  // UI HELPER: REFRESH ONLY (Mit Empty-State Fix & Loop)
  // ---------------------------------------------------------
  function refreshOnlyUI() {
    const cartPageContainer = document.querySelector(SELECTORS.cartPageItems);
    const cartDrawerContainer = document.querySelector(SELECTORS.cartDrawer);
    
    let renderPromise = Promise.resolve();

    if (cartPageContainer) {
       renderPromise = fetch(`${window.Shopify.routes.root}?section_id=main-cart-items`)
        .then(res => res.text())
        .then(text => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newContent = html.querySelector(SELECTORS.cartPageItems);
            if (newContent) cartPageContainer.replaceWith(newContent);
        });
    } else if (cartDrawerContainer) {
        renderPromise = fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
        .then(res => res.text())
        .then(text => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newDrawer = html.querySelector(SELECTORS.cartDrawer);
            if (newDrawer) {
                cartDrawerContainer.innerHTML = newDrawer.innerHTML;
                
                // WICHTIG: Auch hier Klassen fixen
                cartDrawerContainer.className = newDrawer.className;

                // Status "Active" wiederherstellen, da className dies ggf. entfernt hat
                if (document.body.classList.contains('overflow-hidden')) {
                    cartDrawerContainer.classList.add('active');
                }
            }
        });
    }

    renderPromise.then(() => {
        updateBubble();
        isUpdating = false; // API wieder freigeben
        
        // Sicherheits-Check Loop (V6 Feature)
        setTimeout(syncDeposits, 500); 
    });
  }

  function updateBubble() {
    fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
      .then(res => res.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const bubble = document.querySelector(SELECTORS.cartBubble);
        if (bubble) bubble.innerHTML = html.querySelector(SELECTORS.cartBubble).innerHTML;
      });
  }

  // ---------------------------------------------------------
  // INIT & OBSERVER
  // ---------------------------------------------------------
  initAddToCartInterceptor();

  let debounceTimer;
  const triggerSync = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncDeposits, 300);
  };

  const drawerEl = document.querySelector(SELECTORS.cartDrawer);
  if (drawerEl) {
    new MutationObserver(triggerSync).observe(drawerEl, { childList: true, subtree: true });
  }
  
  const cartPageEl = document.querySelector(SELECTORS.cartPageItems);
  if (cartPageEl) {
    new MutationObserver(triggerSync).observe(cartPageEl, { childList: true, subtree: true });
  }
  
  document.addEventListener('cart:updated', triggerSync);
  
  // Initialer Check
  syncDeposits();
});